var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "download-btn-box download-btn-box-big z-index-1" },
    [
      _c(
        "div",
        { staticClass: "download-btn", class: { disabled: _vm.disabled } },
        [
          _c(
            "a",
            {
              staticClass:
                "d-flex gap-10px align-items-center download-btn-main download-btn-primary",
              attrs: { href: _vm.downloadLink },
              on: { click: _vm.downloadJob },
            },
            [
              !_vm.processingDownload && _vm.currentJob.state !== "downloaded"
                ? _c(
                    "svg",
                    {
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "24",
                        height: "21",
                        viewBox: "0 0 19 21",
                        fill: "none",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M19 7.41176H13.5714V0H5.42857V7.41176H0L9.5 16.0588L19 7.41176ZM0 18.5294V21H19V18.5294H0Z",
                          fill: "white",
                        },
                      }),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.processingDownload
                ? _c("i", { staticClass: "fa fa-spin btn-loading-animation" })
                : _vm._e(),
              _vm._v(" "),
              _vm.currentJob.state === "downloaded"
                ? _c(
                    "svg",
                    {
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "24",
                        height: "25",
                        viewBox: "0 0 24 25",
                        fill: "none",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M12 2.75C14.5859 2.75 17.0658 3.77723 18.8943 5.60571C20.7228 7.43419 21.75 9.91414 21.75 12.5C21.75 15.0859 20.7228 17.5658 18.8943 19.3943C17.0658 21.2228 14.5859 22.25 12 22.25C9.41414 22.25 6.93419 21.2228 5.10571 19.3943C3.27723 17.5658 2.25 15.0859 2.25 12.5C2.25 9.91414 3.27723 7.43419 5.10571 5.60571C6.93419 3.77723 9.41414 2.75 12 2.75ZM12 24.5C15.1826 24.5 18.2348 23.2357 20.4853 20.9853C22.7357 18.7348 24 15.6826 24 12.5C24 9.3174 22.7357 6.26516 20.4853 4.01472C18.2348 1.76428 15.1826 0.5 12 0.5C8.8174 0.5 5.76516 1.76428 3.51472 4.01472C1.26428 6.26516 0 9.3174 0 12.5C0 15.6826 1.26428 18.7348 3.51472 20.9853C5.76516 23.2357 8.8174 24.5 12 24.5ZM17.2969 10.2969C17.7375 9.85625 17.7375 9.14375 17.2969 8.70781C16.8563 8.27188 16.1438 8.26719 15.7078 8.70781L10.5047 13.9109L8.30156 11.7078C7.86094 11.2672 7.14844 11.2672 6.7125 11.7078C6.27656 12.1484 6.27187 12.8609 6.7125 13.2969L9.7125 16.2969C10.1531 16.7375 10.8656 16.7375 11.3016 16.2969L17.2969 10.2969Z",
                          fill: "white",
                        },
                      }),
                    ]
                  )
                : _vm._e(),
              _vm._v(
                "\n      " + _vm._s(_vm._f("trans")("Download")) + "\n    "
              ),
            ]
          ),
          _vm._v(" "),
          _vm.resultPage.isMobile === false
            ? _c(
                "div",
                {
                  staticClass: "download-btn-dropdown",
                  on: {
                    click: function ($event) {
                      _vm.dropdownActive = !_vm.dropdownActive
                    },
                  },
                },
                [
                  !_vm.dropdownActive
                    ? _c("i", { staticClass: "far fa-chevron-down" })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.dropdownActive
                    ? _c("i", { staticClass: "far fa-chevron-up" })
                    : _vm._e(),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.resultPage.isMobile === true
            ? _c(
                "div",
                {
                  staticClass: "download-btn-dropdown",
                  on: {
                    click: function ($event) {
                      _vm.dropdownActive = !_vm.dropdownActive
                    },
                  },
                },
                [
                  !_vm.dropdownActive
                    ? _c("i", { staticClass: "far fa-chevron-up" })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.dropdownActive
                    ? _c("i", { staticClass: "far fa-chevron-down" })
                    : _vm._e(),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.dropdownActive &&
          _vm.currentJob.state !== "failed" &&
          _vm.currentJob.state !== "not_found" &&
          _vm.currentJob.state !== "processing" &&
          _vm.currentJob.state !== "unauthorized"
            ? _c("div", { attrs: { id: "download-dropdown" } }, [
                _c("div", { staticClass: "dropdown-item" }, [
                  _c(
                    "span",
                    {
                      staticClass:
                        "px-0 cursor-pointer dropdown-item d-flex text-indent-0 white-space-normal align-items-center",
                      attrs: {
                        id: "downloadZipButton",
                        title: "Download as ZIP",
                      },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.downloadJobAsZip.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._m(0), _vm._v(" Download as ZIP\n        ")]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "dropdown-divider" }),
                _vm._v(" "),
                _c("div", { staticClass: "dropdown-item" }, [
                  _c(
                    "span",
                    {
                      staticClass:
                        "px-0 cursor-pointer dropdown-item d-flex text-indent-0 white-space-normal align-items-center",
                      attrs: {
                        id: "dropboxButton",
                        title: "Choose one or more files from Dropbox",
                      },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.uploadJobToDropbox.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "px-75" }, [
                        _c(
                          "svg",
                          {
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              viewBox: "0 0 43 40",
                              version: "1.1",
                              width: "15px",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "m12.5 0l-12.5 8.1 8.7 7 12.5-7.8-8.7-7.3zm-12.5 21.9l12.5 8.2 8.7-7.3-12.5-7.7-8.7 6.8zm21.2 0.9l8.8 7.3 12.4-8.1-8.6-6.9-12.6 7.7zm21.2-14.7l-12.4-8.1-8.8 7.3 12.6 7.8 8.6-7zm-21.1 16.3l-8.8 7.3-3.7-2.5v2.8l12.5 7.5 12.5-7.5v-2.8l-3.8 2.5-8.7-7.3z",
                                fill: "#007EE5",
                              },
                            }),
                          ]
                        ),
                      ]),
                      _vm._v(
                        " " +
                          _vm._s(_vm._f("trans")("Upload to Dropbox")) +
                          "\n        "
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "dropdown-divider" }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "dropdown-item",
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.uploadJobToGdrive.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass:
                          "px-0 cursor-pointer dropdown-item d-flex text-indent-0 white-space-normal align-items-center",
                        attrs: {
                          id: "gdriveButton",
                          title: "Choose one or more files from Google Drive",
                        },
                      },
                      [
                        _c("span", { staticClass: "px-75" }, [
                          _c(
                            "svg",
                            {
                              attrs: {
                                width: "15px",
                                viewBox: "0 0 87.3 78",
                                xmlns: "http://www.w3.org/2000/svg",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d: "m6.6 66.85 3.85 6.65c.8 1.4 1.95 2.5 3.3 3.3l13.75-23.8h-27.5c0 1.55.4 3.1 1.2 4.5z",
                                  fill: "#0066da",
                                },
                              }),
                              _vm._v(" "),
                              _c("path", {
                                attrs: {
                                  d: "m43.65 25-13.75-23.8c-1.35.8-2.5 1.9-3.3 3.3l-25.4 44a9.06 9.06 0 0 0 -1.2 4.5h27.5z",
                                  fill: "#00ac47",
                                },
                              }),
                              _vm._v(" "),
                              _c("path", {
                                attrs: {
                                  d: "m73.55 76.8c1.35-.8 2.5-1.9 3.3-3.3l1.6-2.75 7.65-13.25c.8-1.4 1.2-2.95 1.2-4.5h-27.502l5.852 11.5z",
                                  fill: "#ea4335",
                                },
                              }),
                              _vm._v(" "),
                              _c("path", {
                                attrs: {
                                  d: "m43.65 25 13.75-23.8c-1.35-.8-2.9-1.2-4.5-1.2h-18.5c-1.6 0-3.15.45-4.5 1.2z",
                                  fill: "#00832d",
                                },
                              }),
                              _vm._v(" "),
                              _c("path", {
                                attrs: {
                                  d: "m59.8 53h-32.3l-13.75 23.8c1.35.8 2.9 1.2 4.5 1.2h50.8c1.6 0 3.15-.45 4.5-1.2z",
                                  fill: "#2684fc",
                                },
                              }),
                              _vm._v(" "),
                              _c("path", {
                                attrs: {
                                  d: "m73.4 26.5-12.7-22c-.8-1.4-1.95-2.5-3.3-3.3l-13.75 23.8 16.15 28h27.45c0-1.55-.4-3.1-1.2-4.5z",
                                  fill: "#ffba00",
                                },
                              }),
                            ]
                          ),
                        ]),
                        _vm._v(
                          " " +
                            _vm._s(_vm._f("trans")("Upload to Google Drive")) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "dropdown-divider" }),
                _vm._v(" "),
                _vm.hasClientId
                  ? _c(
                      "div",
                      {
                        staticClass: "dropdown-item",
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.uploadJobToOneDrive.apply(
                              null,
                              arguments
                            )
                          },
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass:
                              "px-0 cursor-pointer dropdown-item d-flex text-indent-0 white-space-normal align-items-center",
                            attrs: {
                              id: "onedriveButton",
                              title:
                                "Choose one or more files to upload to your OneDrive",
                            },
                          },
                          [
                            _c("span", { staticClass: "px-75" }, [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    width: "15px",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    viewBox: "0 5.5 32 20.5",
                                  },
                                },
                                [
                                  _c("g", { attrs: { id: "STYLE_COLOR" } }, [
                                    _c("path", {
                                      attrs: {
                                        d: "M12.20245,11.19292l.00031-.0011,6.71765,4.02379,4.00293-1.68451.00018.00068A6.4768,6.4768,0,0,1,25.5,13c.14764,0,.29358.0067.43878.01639a10.00075,10.00075,0,0,0-18.041-3.01381C7.932,10.00215,7.9657,10,8,10A7.96073,7.96073,0,0,1,12.20245,11.19292Z",
                                        fill: "#0364b8",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("path", {
                                      attrs: {
                                        d: "M12.20276,11.19182l-.00031.0011A7.96073,7.96073,0,0,0,8,10c-.0343,0-.06805.00215-.10223.00258A7.99676,7.99676,0,0,0,1.43732,22.57277l5.924-2.49292,2.63342-1.10819,5.86353-2.46746,3.06213-1.28859Z",
                                        fill: "#0078d4",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("path", {
                                      attrs: {
                                        d: "M25.93878,13.01639C25.79358,13.0067,25.64764,13,25.5,13a6.4768,6.4768,0,0,0-2.57648.53178l-.00018-.00068-4.00293,1.68451,1.16077.69528L23.88611,18.19l1.66009.99438,5.67633,3.40007a6.5002,6.5002,0,0,0-5.28375-9.56805Z",
                                        fill: "#1490df",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("path", {
                                      attrs: {
                                        d: "M25.5462,19.18437,23.88611,18.19l-3.80493-2.2791-1.16077-.69528L15.85828,16.5042,9.99475,18.97166,7.36133,20.07985l-5.924,2.49292A7.98889,7.98889,0,0,0,8,26H25.5a6.49837,6.49837,0,0,0,5.72253-3.41556Z",
                                        fill: "#28a8ea",
                                      },
                                    }),
                                  ]),
                                ]
                              ),
                            ]),
                            _vm._v(
                              " " +
                                _vm._s(_vm._f("trans")("Upload to OneDrive")) +
                                "\n        "
                            ),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "px-75" }, [
      _c("i", { staticClass: "far fa-file-archive" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }